import { http } from "@silvertours/front-shared";
import { useEffect } from "react";
import { getDefaults } from "../defaults";
import { useConfig, useLocale } from "../../Runtime";
var useGetSiteInfo = function() {
    var api = useConfig().api;
    var locale = useLocale().locale;
    var defaults = getDefaults(locale);
    var ref = http.useClientSideRequest(api.host, http.API.siteSettings), settingsData = ref.data, settingsRequest = ref.request;
    var ref1 = http.useClientSideRequest(api.host, http.API.openingHours), openingTimesData = ref1.data, openingTimesRequest = ref1.request;
    useEffect(function() {
        settingsRequest("get");
        openingTimesRequest("get");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        settings: settingsData || defaults.settings,
        openingTimes: openingTimesData || defaults.openingTimes,
        settingsLoaded: !!settingsData
    };
};
export { useGetSiteInfo };
